export enum EVisitDocumentManagementStatus {
  RECONCILE = 'RECONCILE',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}
